import { I18N } from 'core-cmp/util/I18n'
import { createDateMode } from 'core-metoc/ui/multiLayer/modeDate.utils'
import { APP } from 'core-uda/model/Resource'

const modeMobilePositionDate = createDateMode({
  type: 'mobilePosition',
  modelType: 'current',
  dateEditor: false,
  icon: 'vessel',
  label: () =>
    I18N.msg('core-metoc.ui.multiLayer.MultiLayerPage.mobilePosition'),
})

export function listenChangeMetocDateWithPosition() {
  APP().on(
    'changeMetocDateWithPosition',
    (ev: any, mobileId?: string, posIndex?: number) => {
      const position = APP('trajectories', mobileId ?? '')?.positions?.[
        posIndex
      ]
      if (!position) {
        modeMobilePositionDate.setHasData(false)
        return
      }
      modeMobilePositionDate.setHasData(true)
      modeMobilePositionDate.setDate(position.locDate)
    },
  )
}

export default modeMobilePositionDate
